import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate,useParams } from 'react-router';
import { editPark, getParkItem } from '../../redux/actions/parks';




const Map = ()=>{
  const [load, setLoad] = useState({'lat':50.4393067,'lon':30.5479288});
  const [ready,setReady]=useState(false);
  const [modal,setModal]=useState(false);
  const [reason,setReason]=useState({});
  const navigate= useNavigate();
  const [coords, setCoords] = useState({});
  const currentId = useParams().id;
  const {parks} = useSelector((state) => state);
  const {listId} = useSelector((state) => state);
  let coordinates = parks.location
  const dispatch = useDispatch();


    let pos;
    let map;
    var marker;
    let geocoder;
    let infoWindow;
    

    const initFunction=()=>{
      dispatch(getParkItem({id:currentId})).then(res=>{
        if(window.google && document.getElementById("googleMap")){
          initMap();
                  }
      if(window.google){
          initMap();
      }

      if(coordinates){
        initMap(coordinates);
      }
        setReady(true);
      })
    }

    const initMap=useCallback((coordinates)=> {

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {  
            var current_latitude = position.coords.latitude;
            var current_longitude = position.coords.longitude;
            let pos= {'lat':current_latitude, 'lon':current_longitude}
            setLoad(pos)
        }); 
      } 
        let map = new  window.google.maps.Map(document.getElementById("googleMap"), {
                center: new  window.google.maps.LatLng(load.lat,load.lon),
                zoom: 5,
                streetViewControl: false,
                zoomControl: false,
            });

        let customStyled = [
              {
                  featureType: "all",
                  elementType: "labels.icon",
                  stylers: [
                      { visibility: "off" }
                  ]
              }
          ];
      map.set('styles',customStyled);   

        infoWindow = new window.google.maps.InfoWindow();
        geocoder = new window.google.maps.Geocoder();
        const labelForInput = document.createElement("div");
        const inputText = document.createElement("input");
        labelForInput.classList.add('apInputText')
        inputText.type = "text";
        inputText.placeholder = "Адреса або координати";
        labelForInput.appendChild(inputText);
        const submitButton = document.createElement("button");

        submitButton.type = "button";
        submitButton.innerHTML = "Знайти";
        submitButton.classList.add("primaryButtonTextDefault");

       

        submitButton.style='margin: 10px 5px 0px 5px;'
        labelForInput.style='margin: 0px 5px 0px 5px;'
        inputText.style='margin: 10px 5px 0px 5px;'

        const cancelButton = document.createElement("button");
        cancelButton.innerHTML='Назад';
        cancelButton.classList.add("primaryButtonTextDefault");
        cancelButton.style='margin: 0 5px 10px 5px;'
        const saveButton = document.createElement("button");
        saveButton.innerHTML='Зберегти зміни';
        saveButton.classList.add("primaryButtonTextDefault");
        saveButton.style='margin: 0 5px 10px 0px;'

        map.controls[window.google.maps.ControlPosition.BOTTOM_LEFT].push(cancelButton);

        if(parks&&parks.statusId!=="036735ba-f634-469b-ac30-77a164e3a918"&& parks.statusId!=="99ca4f35-663c-4e0a-b9ef-f70219aa8163"){
          map.controls[window.google.maps.ControlPosition.BOTTOM_LEFT].push(saveButton);
          map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(labelForInput);
          map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(submitButton);        
        }


        marker = new window.google.maps.Marker({
              map,
        });


    const geocode =(request)=> {
        clear();
        geocoder.geocode(request).then((result) => {
          const { results } = result;

          if(request.location && request.location.lat && request.location.lng){
            pos = request.location;
            
          }else if(request.address){
            pos =results[0].geometry.location;
          }

          if(parks&&parks.statusId!=="036735ba-f634-469b-ac30-77a164e3a918"&& parks.statusId!=="99ca4f35-663c-4e0a-b9ef-f70219aa8163"){
            marker= new window.google.maps.Marker({
              position:pos,
              map: map,
              draggable:true,
            });
          }else{
            marker= new window.google.maps.Marker({
              position:pos,
              map: map,
              draggable:false,
            });
          }
          
          // marker= new window.google.maps.Marker({
          //   position:pos,
          //   map: map,
          //   draggable:true,
          // });
          results[0].address_components.forEach(el=>{
            let field = el.types[0]
            pos[field] = el.short_name
          })
          setCoords({...coords,...pos})
              let adress = results[0].address_components;
              let currentLat;
              let currentLon;


          if(typeof pos.lat === 'function'){
            currentLat = pos.lat()
            // pos.lat= currentLat;
            currentLon = pos.lng()
            // pos.lng= currentLon
          }else{
            currentLat = pos.lat
            currentLon = pos.lng
          }

              let positMark = {
                lat: currentLat,
                lng: currentLon,
              }

            // infoWindow.setPosition(request.location);
            // infoWindow.setContent(`${positMark.lat.toFixed(7)} ${positMark.lng.toFixed(7)}<br/> Geo position<br/>${adress}<br/><button>Click</button><br/><img loading="lazy" style='width:50px; height:50px; margin:0 31%;' src='data:image/jpeg;base64,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'></img> `);
            // infoWindow.open(map);
            // infoWindow.setContent(`Майданчик<br/>АА2345 <br/>  Не активна`)
            map.setCenter(positMark);

            map.setZoom(18)
            
            if(parks&&parks.statusId!=="036735ba-f634-469b-ac30-77a164e3a918"&& parks.statusId!=="99ca4f35-663c-4e0a-b9ef-f70219aa8163"){
              window.google.maps.event.addListener(marker, 'dragend', function(marker){
                let latLng 
                if (marker.position){
                  latLng = marker.position
                } else if(marker.latLng){
                  latLng = marker.latLng
                }
                geocode({location: latLng})
              })
              window.google.maps.event.addListener(marker, 'click', function(marker){
                let latLng 
                if (marker.position){
                  latLng = marker.position
                } else if(marker.latLng){
                  latLng = marker.latLng
                }
                geocode({location: latLng})
              })
            }
            return  result;
            })
            .catch((e) => {
              setModal(true);
              setReason(e);
            });
    }

      
      
    if(coordinates && coordinates.length>0){
      geocode({location:{
        lat:+coordinates[0],
        lng:+coordinates[1]
      }})
    }
    if(parks&&parks.statusId!=="036735ba-f634-469b-ac30-77a164e3a918" && parks.statusId!=="99ca4f35-663c-4e0a-b9ef-f70219aa8163"){
      map.addListener("click", (e) => {

        geocode({ location: e.latLng });
        setCoords({location: e.latLng})
        // placeMarkerAndPanTo(e.latLng, map)
    });
    }
        submitButton.addEventListener("click", () =>
            geocode({ address: inputText.value })
        );
       


        saveButton.addEventListener('click',()=>{
          
          if(typeof pos.lat === 'function'){
            pos.lat = pos.lat().toFixed(7)
            pos.lng = pos.lng().toFixed(7)
          }
          editItem(pos)
          // sessionStorage.setItem('coordinates', JSON.stringify({...pos}))
        })
        
        function getKeyByValue(object, value) {
          let val = Object.keys(object).find(key => object[key] === value);
          return val
        }
        const editItem=(coord)=>{
          let result = {id:currentId}
          if(coord &&  (coord.administrative_area_level_1 || coord.administrative_area_level_2)){
            result.street = coord.route;
            result.city = coord.locality;
            result.regionId='';
            result.districtId=''
            result.location=[];
            result.location[0]=+coord.lat;
            result.location[1]=+coord.lng;

            if(coord.administrative_area_level_1&& coord.administrative_area_level_1.split(' ')[1]==='область'){
              let str = coord.administrative_area_level_1.split(' ')
              let val=str[1].slice(0,3);
              val+='.'
              let newStr = str[0]+' '+val;
              result.regionId = getKeyByValue(listId.list,newStr);
            }else if(coord.administrative_area_level_1){
              result.regionId = getKeyByValue(listId.list, coord.administrative_area_level_1);
            }
            if(coord.location && coord.location[0]){
             result.location=coord.location;
            }
            if(!result.regionId){
              result.regionId= getKeyByValue(listId.list, coord.administrative_area_level_2);
              result.districtId="";
            }else if(result.regionId && coord.administrative_area_level_2){
              result.districtId= getKeyByValue(listId.list, coord.administrative_area_level_2)
            }
            
          }
          if(result.districtId===result.regionId){
            result.districtId='';
          }

          dispatch(editPark(result)).then(res=>{
            // getItem()
            
            navigate(`/sportsground/${currentId}/info`)
          }).catch(e=>{
            console.log(e)
          })
        }
        cancelButton.addEventListener('click',(e)=>{
          e.preventDefault()
          navigate(`/sportsground/${currentId}/info`)
        })
        clear();
        let zoomInButton, zoomOutButton,myLocationButton;
        zoomInButton = document.createElement("button");
        zoomOutButton = document.createElement("button");
        myLocationButton = document.createElement("button");
        zoomInButton.type='button';
        zoomOutButton.type='button';
        myLocationButton.type='button';
        zoomInButton.value='Збільшити';
        zoomOutButton.value='Зменшити';
        myLocationButton.value='My Location';
        zoomInButton.classList.add("primaryMediumButtonIconDefault", "apMapZoomButton",'zoom-control-in');
        zoomOutButton.classList.add("primaryMediumButtonIconDefault", "apMapZoomButton",'zoom-control-out');
        myLocationButton.classList.add("primaryMediumButtonIconDefault", "apMapZoomButton");
        zoomInButton.innerHTML='<svg><use href="/images/icon24Plus.svg#icon24"></use></svg>';
        zoomOutButton.innerHTML='<svg><use href="/images/icon24Minus.svg#icon24"></use></svg>';
        myLocationButton.innerHTML='<svg><use href="/images/icon24MyLocation.svg#icon24"></use></svg>';
        map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(zoomInButton);
        map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(zoomOutButton);
        map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(myLocationButton);
        zoomInButton.onclick = function () {
              map.setZoom(map.getZoom() + 1);
            };
          
        zoomOutButton.onclick = function () {
              map.setZoom(map.getZoom() - 1);
            };
            myLocationButton.onclick= () => {
                if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition(
                    (position) => {
                      const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                      };
                     
                      geocode({location:pos})
                     
                      // map.setCenter(pos)
                      if(map.getZoom()<10){
                        map.setZoom(10)
                      }else if(map.getZoom()>=18){
                        map.setZoom(17)
                      }else{
                        map.setZoom(map.getZoom()+1)
                      }
                    },
                    () => {
                      handleLocationError(true, infoWindow, map.getCenter());
                    }
                  );
                } else {
                  handleLocationError(false, infoWindow, map.getCenter());
                }
              };
      })         
        function handleLocationError(browserHasGeolocation, infoWindow, pos) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                  browserHasGeolocation
                    ? "Error: The Geolocation service failed."
                    : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
        }

    function clear() {
        marker.setMap(null);
    }
  
    useEffect(()=>{
        if(!ready){
          initFunction();
        }
      if(window.google && document.getElementById("googleMap")){
          initMap();
                  }
      if(window.google){
          initMap();
      }
      if(coordinates){
        initMap(coordinates);
      }
    },[window.google])

    return(
        <>
            <h1>Картка майданчика</h1>
            
                  <div id="googleMap" className='' style={{'minWidth':'360px','maxWidth':'1200px','min-height':'600px'}}></div>
          {modal&& 
            <div Name='apInformation'>
              <svg onClick={()=>setModal(false)}><use href="/images/icon24Cancel.svg#icon24"></use></svg>
              <div>{reason.message}</div>
            </div>
          }
        </>
    )
}


export default Map;
